import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Type } from '@angular/core';
import { Section } from '../../../editor-container/editor-model';
import { RenderedSection, SectionEditorBridgeService } from '../../../services/section-editor-bridge.service';
import { Subject, Subscription } from 'rxjs';
import { RowCell } from '@urbannex/storethemes';
import { NbDialogService } from '@nebular/theme';
import { PreviewEditStoreService } from '../../../services/preview-edit-store.service';
import { takeUntil } from 'rxjs/operators';
import { EditorDialogComponent } from '../../dialogs/editor-dialog/editor-dialog.component';
import { EditState } from '../../../model';

@Component({
  selector: 'kve-row-editor',
  templateUrl: './row-editor.component.html',
  styleUrls: ['./row-editor.component.scss']
})
export class RowEditorComponent implements OnInit,OnDestroy {
  @Input() selectedSection:Section;
  @Input() selectedRenderedSection:RenderedSection;
  elementId:string;
  gridThumbnails:any[];
  gridThumbnails$:Subscription;
  cellIdsThumbs:any[];
  cellIdsThumbs$:Subscription;
  selectedCell:RowCell;


  @Output() setListMode = new EventEmitter();

  private destroy$: Subject<void> = new Subject<void>();
  constructor(private sectionEditorBridge:SectionEditorBridgeService,
    private dialogService: NbDialogService,
    private previewEditStoreService:PreviewEditStoreService) { }
  

  ngOnInit(): void {
    this.gridThumbnails$ = this.sectionEditorBridge.getSectionThumbnails().pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      console.log(`Track ThumbNails: ${data}`)
      this.gridThumbnails = data;
    })
    this.cellIdsThumbs$ = this.sectionEditorBridge.getCellIdsThumbs().pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      console.log(`Track Ids: ${data}`)
      this.cellIdsThumbs = data;
    })
  }

  goBack(e){
    this.setListMode.emit();
  }

  open(options:any){
    //image header footer link
    const action = options["action"];
    const imgSrc = options["imgSrc"];
    const cellId = options["cellId"];
    this.previewEditStoreService.setSelectedCell(cellId);
    this.resolveSelectedCell(cellId)
    //console.log(options)
    //SampleImageDirectoryComponent
    let component:Type<any> = EditorDialogComponent;
    let title = "Title"
    switch (action) {
      case "image":
        component = EditorDialogComponent;
        title = "Edit Cell"
        break;
    
      default:
        break;
    }
    this.previewEditStoreService.updateEditState(EditState.EDITING);
    let dialogRef = this.dialogService.open(component,{
      context: {
        title: title,
        imgSrc:imgSrc,
        cellId:cellId,
        section:this.selectedSection,
        selectedCell:this.selectedCell,
        dialogWidth:960
      },
    })

    dialogRef.onClose.subscribe((resp:RowCell) => {
      console.log(resp);
      console.log(this.cellIdsThumbs);
      if(this.cellIdsThumbs != undefined){
        let activeCell = this.cellIdsThumbs.find(cell => cell.cellId == resp.cellId);
        if(activeCell != null && activeCell != undefined){
          activeCell.imgSrc = resp.imgSrc;
        }
      }
      this.previewEditStoreService.updateSelectedCell(resp)
      this.previewEditStoreService.updateEditState(EditState.UPDATED)
    })

  }

  resolveSelectedCell(cellId){
    if(cellId != undefined){
    console.log(cellId)
    let cells:RowCell[] = this.selectedSection.sectionData.rowOptions.rowCells;
    console.log(cells)
    if(cells != undefined && cells.length > 0){
      this.selectedCell = cells.find(cell => cell.cellId == cellId);
      console.log(this.selectedCell)
    }
   }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
